module.exports = __webpack_public_path__ + "a23cb169d97650546d2771d6d1502862.jpg";